import { WorklistColumnId } from 'generated/graphql';

export const DEFAULT_VIEWER_STUDIES_DIALOG_COLUMNS: Array<WorklistColumnId> = [
  WorklistColumnId.SelectCheckbox,
  WorklistColumnId.MatchType,
  WorklistColumnId.PatientName,
  WorklistColumnId.StudyDate,
  WorklistColumnId.StudyDescription,
  WorklistColumnId.Modality,
  WorklistColumnId.Site,
  WorklistColumnId.Mrn,
  WorklistColumnId.AccessionNumber,
];

export const TEXT_SELECTABLE_CELLS: Array<WorklistColumnId> = [
  WorklistColumnId.PatientName,
  WorklistColumnId.Mrn,
  WorklistColumnId.AccessionNumber,
];

export const DEFAULT_COLUMN_ORDERING: Array<WorklistColumnId> = [
  WorklistColumnId.SelectCheckbox,
  WorklistColumnId.Actions,
  WorklistColumnId.QcStatus,
  WorklistColumnId.Status,
  WorklistColumnId.Priority,
  WorklistColumnId.ExamStatus,
  WorklistColumnId.SubmittedAt,
  WorklistColumnId.StudyDate,
  WorklistColumnId.FirstVerifiedStatusDate,
  WorklistColumnId.Mrn,
  WorklistColumnId.PatientName,
  WorklistColumnId.PatientType,
  WorklistColumnId.PatientDob,
  WorklistColumnId.Age,
  WorklistColumnId.PatientSex,
  WorklistColumnId.Modality,
  WorklistColumnId.Specialty,
  WorklistColumnId.AccessionNumber,
  WorklistColumnId.StudyDescription,
  WorklistColumnId.BodyPart,
  WorklistColumnId.DicomInstanceCount,
  WorklistColumnId.Site,
  WorklistColumnId.Radiologist,
  WorklistColumnId.CustomStatus,
  WorklistColumnId.HasDraftReport,
  WorklistColumnId.HasPrelimReport,
  WorklistColumnId.ReportExtendedStatus,
  WorklistColumnId.ReferringPhysician,
  WorklistColumnId.SignedBy,
  WorklistColumnId.ExamCode,
  WorklistColumnId.Due,
];

export const DEFAULT_SUBMITTED_COLUMN_ORDERING: Array<WorklistColumnId> = [
  WorklistColumnId.SelectCheckbox,
  WorklistColumnId.Actions,
  WorklistColumnId.Status,
  WorklistColumnId.Priority,
  WorklistColumnId.ExamStatus,
  WorklistColumnId.SubmittedAt,
  WorklistColumnId.StudyDate,
  WorklistColumnId.FirstVerifiedStatusDate,
  WorklistColumnId.Mrn,
  WorklistColumnId.PatientName,
  WorklistColumnId.PatientType,
  WorklistColumnId.PatientDob,
  WorklistColumnId.Age,
  WorklistColumnId.PatientSex,
  WorklistColumnId.Modality,
  WorklistColumnId.Specialty,
  WorklistColumnId.AccessionNumber,
  WorklistColumnId.StudyDescription,
  WorklistColumnId.BodyPart,
  WorklistColumnId.DicomInstanceCount,
  WorklistColumnId.Site,
  WorklistColumnId.Radiologist,
  WorklistColumnId.SignedBy,
  WorklistColumnId.CustomStatus,
  WorklistColumnId.HasDraftReport,
  WorklistColumnId.HasPrelimReport,
  WorklistColumnId.ReportExtendedStatus,
  WorklistColumnId.ReferringPhysician,
  WorklistColumnId.ExamCode,
];

export const DEFAULT_COLUMNS: Array<WorklistColumnId> = [
  WorklistColumnId.SelectCheckbox,
  WorklistColumnId.Actions,
  WorklistColumnId.Status,
  WorklistColumnId.Priority,
  WorklistColumnId.StudyDate,
  WorklistColumnId.PatientName,
  WorklistColumnId.StudyDescription,
  WorklistColumnId.Site,
];

export const DEFAULT_PATIENT_JACKET_PRIORS_COLUMNS: Array<WorklistColumnId> = [
  WorklistColumnId.Actions,
  WorklistColumnId.Status,
  WorklistColumnId.MatchType,
  WorklistColumnId.ExamStatus,
  WorklistColumnId.StudyDate,
  WorklistColumnId.StudyDescription,
  WorklistColumnId.Modality,
  WorklistColumnId.BodyPart,
  WorklistColumnId.Site,
  WorklistColumnId.PatientType,
];

export const DEFAULT_SUBMITTED_COLUMNS: Array<WorklistColumnId> = [
  WorklistColumnId.Actions,
  WorklistColumnId.Status,
  WorklistColumnId.Priority,
  WorklistColumnId.SubmittedAt,
  WorklistColumnId.StudyDate,
  WorklistColumnId.PatientName,
  WorklistColumnId.StudyDescription,
  WorklistColumnId.Site,
  WorklistColumnId.SignedBy,
];

export const DEFAULT_QC_COLUMNS: Array<WorklistColumnId> = [
  WorklistColumnId.Actions,
  WorklistColumnId.QcStatus,
  WorklistColumnId.Priority,
  WorklistColumnId.SubmittedAt,
  WorklistColumnId.StudyDate,
  WorklistColumnId.PatientName,
  WorklistColumnId.StudyDescription,
  WorklistColumnId.Site,
];

export const CELL_BACKGROUND_NOT_CLICKABLE: Array<string> = [
  'selectCheckbox',
  'actions',
  'caseMenu',
] as const;
